module.exports = __webpack_public_path__ + "img/VI.2cca2f61.svg";